import { api } from '../../plugins/api';

const getDefaultState = () => {
  return {
    attestationVeracite: {
      id: 0,
      identiteEtRenseignements: false,
      honneteteFideliteJusticeEtSecret: false,
      exercerAuxConditionsEtNormes: false,
      contactEtablissementEtSuperviseur: false,
      suivreFormations: false,
      validiteDocuments: false,
      fausseDeclaration: false,
      modaliteDemandeAdmission: false,
      formationContinue: false,
      demandeAdmission: '',
      pp: '',
      active: true
    }
  }
}

const state = getDefaultState()

const getters = {
  GET_ATTESTATIONSVERACITES: (state) => { return state.attestationVeracite }
}

const mutations = {
  SET_ID(state, id){
    state.attestationVeracite.id = id
  },
  SET_CONTACTID(state, id){
    state.attestationVeracite.pp = id
  },
  SET_DEMANDEADMISSIONID(state, id){
    state.attestationVeracite.demandeAdmission = id
  },
  SET_ATTESTATIONVERACITE(state, attestation) {
    state.attestationVeracite = {...attestation}
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  async getAttestationsVeracitesByContactId({ commit }, contactId) {
    const response = await api.get(`attestationsveracites/contact/` + contactId);
    commit("SET_ATTESTATIONVERACITE", response.data ? response.data : 
      getDefaultState().attestationVeracite)
  },
  async getAttestationsVeracitesByDemandeAdmissionId({ commit }, demandeAdmissionId) {
    const response = await api.get(`attestationsveracites/demandesadmissions/` + demandeAdmissionId);
    commit("SET_ATTESTATIONVERACITE", response.data && response.data[0] ? response.data[0] : 
      getDefaultState().attestationVeracite)
  },
  async getAttestationsVeracitesByDemandeInscriptionId({ commit }, demandeInscriptionId) {
    const response = await api.get(`attestationsveracites/demandesinscriptions/` + demandeInscriptionId);
    commit("SET_ATTESTATIONVERACITE", response.data && response.data[0] ? response.data[0] :
      getDefaultState().attestationVeracite)
  },
  async createAttestationsVeracites({ commit }, pDemandeAdmissionDTO){
    const response = await api.post(`attestationsveracites`, pDemandeAdmissionDTO);
    commit('SET_ID', response.data);
  },
  async getLinkedContactEncryptedId({ commit }, encryptedId){
    const response = await api.get(`attestationsveracites/${encryptedId}/contact`);
    commit('SET_CONTACTID', response.data ? response.data : null);
  },
  async updateAttestationsVeracites({ commit }, pDemandeAdmissionDTO){
    const response = await api.put(`attestationsveracites`, pDemandeAdmissionDTO);
    commit('SET_ATTESTATIONVERACITE', response.data ? response.data : null);
  },
  getAttestationsVeracites({state}, encryptedId){
    return api.get(`attestationsveracites/` + encryptedId);
  },
  resetModuleState ({ commit }) {
    commit('resetState')
  },
}

export default ({
    namespaced: true,
    state: state,
    mutations: mutations,
    getters: getters,
    actions: actions
})